import {
    Directive, ElementRef, EventEmitter, HostListener, Output
} from '@angular/core';
import {ClickOutsideEvent} from '../interfaces/click-outside-event.interface';

@Directive({
    selector: '[eocmClickOutside]'
})
export class ClickOutsideDirective {

    @Output() clickOutside: EventEmitter<ClickOutsideEvent> = new EventEmitter();

    @HostListener('document:click', ['$event']) onClick(event: MouseEvent) {
        if (this.el.nativeElement === event.target || this.isChildElementClicked(event.target)) {
            this.clickOutside.emit({
                clickedOutside: false, clickedElement: event.target
            });
        } else {
            this.clickOutside.emit({
                clickedOutside: true, clickedElement: event.target
            });
        }
    }

    constructor(private el: ElementRef) {
    }

    private isChildElementClicked(targetedElement) {
        const children = this.el.nativeElement.children;
        if (children.length < 1) {
            return false;
        } else {
            let isItChildElement = false;
            for (const item of children) {
                if (item.contains(targetedElement)) {
                    isItChildElement = true;
                }
            }
            return isItChildElement;
        }
    }
}
